export const sociometryLabels = [
    {
        color: "#8ebe6e",
        title: "Звезды",
        label: "stars",
        description:
            "<span class='popup-title'>«Звезды»</span> - субъект, который является наиболее привлекательной личностью для остальных членов группы. «Звезды» всегда получают наибольшее количество положительных выборов.",
    }, // Звезды - Плюсы = максимум по классу; при равенстве плюсов – выбирается с наименьшими минусами (один человек). Если есть несколько учеников, у которых максимальное количество плюсов и одинаковое минимальное количество минусов, то они оба являются звездами
    {
        color: "#ffd144",
        title: "Предпочитаемые",
        label: "preferred",
        description:
            "<span class='popup-title'>Предпочитаемые</span> - члены группы, получившие в большей степени положительные выборы и вовсе не получившие или в минимальном количестве число отвержений. Эти люди также являются востребованными и популярными в группе, могут претендовать на статус «звезды», если полностью избавятся от оценок отвержения и так же получат одобрения со стороны других членов группы.",
    }, // Не звезда, и плюсы > минусы
    {
        color: "#f09354",
        title: "Пренебрегаемые",
        label: "ignored",
        description:
            "<span class='popup-title'>Пренебрегаемые</span> лица- члены группы, получившие минимальное число положительных выборов, при этом имеют большое число отвержений от остальных членов группы. Таким людям будет проблематично стать «звездами» поэтому они предпочитают и дальше занимать данную позицию.",
    }, // Пренебрегаемые - Не звезда, не предпочитаемый, и минусы > плюсы, либо минусы = плюсам (за исключением, когда плюсы = 0 и минусы = 0 у одного ученика, тогда он изолированный)
    {
        color: "#ff3737",
        title: "Изолированные",
        label: "isolated",
        description:
            "<span class='popup-title'>Изолированные</span>, или нейтральные - у данных членов группы нет ни положительных, ни отрицательных выборов, так как они не вызывают у других членов группы ни положительных, ни отрицательных эмоций. У «изолированных» есть большие шансы стать или предпочитаемыми, или пренебрегаемыми, или отверженными.",
    }, // Изолированные - Плюсы = 0, минусы = 0
    {
        color: "",
        title: "Отверженные ",
        label: "rejected",
        description:
            "<span class='popup-title'>Отверженные</span>, или изгои - члены группы с данным социометрическим статусом имеют только отрицательные выборы. В данную группу чаще всего входят те люди, чье мнение не совпадает с мнением группы, их мировоззрение и социальные привычки вызывают негативную реакцию со стороны других членов группы.",
    }, // Отверженные - Плюсы = 0, минусы > 0
];
